import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAirpods: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAirpods"><Path d="M6 13C4.3644 13 2.91223 12.2147 2 11.0005V4.99951C2.91223 3.78534 4.3644 3 6 3C8.76142 3 11 5.23858 11 8L11 21H7V12.9C6.67689 12.9656 6.34247 13 6 13Z" fill="currentColor"/><Path d="M18 13C19.6356 13 21.0878 12.2147 22 11.0005V4.99951C21.0878 3.78534 19.6356 3 18 3C15.2386 3 13 5.23858 13 8L13 21H17V12.9C17.3231 12.9656 17.6575 13 18 13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAirpods;
